module.exports = __webpack_public_path__ + "static/media/2_game-icon.c5530491.png";